module.exports = __webpack_public_path__ + "img/03.d74904fa.png";